var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hot-wrapper" }, [
    _c("div", { staticClass: "hot-tab" }, [
      _c(
        "ul",
        _vm._l(_vm.tab, function (item, index) {
          return _c(
            "li",
            {
              key: index,
              class: { cur: item.checked },
              attrs: { uigs: "tab_" + index },
              on: {
                click: function ($event) {
                  return _vm.aClick(item, index)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "hot-list" },
      _vm._l(_vm.list, function (item, index) {
        return _c(
          "li",
          { key: index, attrs: { uigs: "in_search_hotword_" + item.name } },
          [_c("a", { attrs: { href: item.url } }, [_vm._v(_vm._s(item.name))])]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }